import React from "react";
import { Button } from "react-bootstrap";

const StepWelcome: React.FC<{ onNext: () => void }> = ({ onNext }) => (
  <div className="wizard-card">
    <div className="wizard-header">Create a Public Listing</div>
    <div className="wizard-description">
      Create a public page to display Stripe-verified revenue for your project.
      You'll configure what details are shown.
    </div>
    <div className="reassurance">You can hide your page at any time.</div>
    <div className="reassurance">
      You'll see a preview before it goes public.
    </div>
    <div className="wizard-nav">
      <div />
      <Button variant="primary" onClick={onNext}>
        Get Started
      </Button>
    </div>
  </div>
);

export default StepWelcome;
